import { WixStyleReactProviderProps } from '../WixStyleReactProvider';

export interface WixDesignSystemProviderProps
  extends WixStyleReactProviderProps {}
